import api from './api';
import { ApiItem } from '../types/api';

export interface ApiConfigurationDTO {
  id?: number;
  name: string;
  displayName: string;
  description?: string;
  category?: string;
  endpointUrl?: string;
  apiKey?: string;
  isActive?: boolean;
  configJson?: Record<string, any>;
}

export interface ApiConfigurationResponse {
  success: boolean;
  message: string;
  data: any;
}

export interface ApiConfigurationListResponse {
  success: boolean;
  message: string;
  data: any[];
}

/**
 * API Configuration 서비스
 */
class ApiConfigurationService {
  /**
   * API 설정 목록 조회
   */
  async getApiConfigurations(params?: {
    category?: string;
    isActive?: boolean;
  }): Promise<ApiConfigurationListResponse> {
    const response = await api.get('/api-configurations', { params });
    return response.data;
  }

  /**
   * API 설정 상세 조회
   */
  async getApiConfiguration(id: number): Promise<ApiConfigurationResponse> {
    const response = await api.get(`/api-configurations/${id}`);
    return response.data;
  }

  /**
   * API 설정 생성
   */
  async createApiConfiguration(data: ApiConfigurationDTO): Promise<ApiConfigurationResponse> {
    const response = await api.post('/api-configurations', data);
    return response.data;
  }

  /**
   * API 설정 수정
   */
  async updateApiConfiguration(
    id: number,
    data: Partial<ApiConfigurationDTO>
  ): Promise<ApiConfigurationResponse> {
    const response = await api.patch(`/api-configurations/${id}`, data);
    return response.data;
  }

  /**
   * API 설정 삭제
   */
  async deleteApiConfiguration(id: number): Promise<ApiConfigurationResponse> {
    const response = await api.delete(`/api-configurations/${id}`);
    return response.data;
  }

  /**
   * API 활성화 상태 일괄 변경
   */
  async bulkToggleActive(
    ids: number[],
    isActive: boolean
  ): Promise<ApiConfigurationResponse> {
    const response = await api.patch('/api-configurations/bulk-toggle', {
      ids,
      isActive,
    });
    return response.data;
  }

  /**
   * 전체 API 헬스체크
   */
  async healthCheckAll(activeOnly: boolean = false): Promise<ApiConfigurationResponse> {
    const response = await api.get('/api-configurations/health-check', {
      params: { activeOnly }
    });
    return response.data;
  }

  /**
   * 개별 API 헬스체크
   */
  async healthCheckById(id: number): Promise<ApiConfigurationResponse> {
    const response = await api.get(`/api-configurations/${id}/health-check`);
    return response.data;
  }
}

export const apiConfigurationService = new ApiConfigurationService();
export default apiConfigurationService;
